import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { routes } from '../../pages/routes'
import { Fragment, useEffect } from 'react'
import { DEFAULT_OAUTH_SCOPES, ssoClientConfigMappings } from './config'
import { ssoStorage } from './ssoStorage'
import { generateOAuthState } from './ssoState'
import type { ClientSSOContext } from './types'

export const SSOLandingPage = () => {
  const { ssoClientNameParam = '' } = useParams()
  const [searchParams] = useSearchParams()
  const ssoClientName = ssoClientNameParam?.toUpperCase()
  const navigate = useNavigate()
  const client = ssoClientConfigMappings.find((client) => client.clientName === ssoClientName)
  const clientId = client?.clientId || ''
  const identityProvider = client?.identityProvider || ''

  useEffect(() => {
    if (!ssoClientName || !clientId) {
      navigate(routes.login.path)
      return
    }
    localStorage.clear()
    const paramsObject: { [key in string]: string } = {}
    searchParams.forEach((value, key) => {
      paramsObject[key.toLowerCase()] = value
    })
    if (paramsObject.returnto) {
      ssoStorage.setRedirectUrl(`/${paramsObject.returnto}`)
    }
    const clientSSOContext: ClientSSOContext = {
      externalPatientFetchId: paramsObject['eprescriptiondatafeedid'] || paramsObject['patientid'],
      referralId: paramsObject?.['referralid'],
      clientName: client?.clientName,
      providerId: client?.providerId,
      metadata: Object.fromEntries(searchParams.entries()),
      providerPlatform: client?.providerPlatform,
      providerType: client?.providerType,
    }
    ssoStorage.setContext(clientSSOContext)
    const baseUrl = `${process.env.REACT_APP_COGNITO_AUTH_URI}/authorize`
    const redirectUri = `${process.env.REACT_APP_COGNITO_REDIRECT_URI}/${clientId}`
    const params = new URLSearchParams({
      response_type: 'code',
      identity_provider: identityProvider,
      client_id: clientId,
      scope: (client?.oauthScopes ?? DEFAULT_OAUTH_SCOPES).join(' '),
      state: generateOAuthState(ssoClientName),
    })
    window.location.href = `${baseUrl}?${params.toString()}${'&redirect_uri=' + redirectUri}`
  }, [searchParams, identityProvider, navigate, clientId, ssoClientName])
  return <Fragment />
}
